module.exports = __webpack_public_path__ + "static/media/play-store-badge.0777a917.png";